import {
  BodyText,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui";
import { type Message, MessageRow } from "./MessageRow";

interface MessagesTableProps {
  messages: Message[] | undefined;
  isLoading?: boolean;
  isError?: boolean;
  archived?: boolean;
}

export const MessagesTable = ({
  messages,
  isLoading,
  isError,
  archived,
}: MessagesTableProps) => {
  return (
    <Table className="min-w-[800px]">
      <TableHeader>
        <TableRow>
          <TableHead className="w-64">
            <BodyText bold={true} size="sm" textColor="tertiary">
              Name
            </BodyText>
          </TableHead>
          <TableHead className="w-40">
            <BodyText bold={true} size="sm" textColor="tertiary">
              Age & Sex
            </BodyText>
          </TableHead>
          <TableHead className="w-40">
            <BodyText bold={true} size="sm" textColor="tertiary">
              State
            </BodyText>
          </TableHead>
          <TableHead className="w-40">
            <BodyText bold={true} size="sm" textColor="tertiary">
              Customer
            </BodyText>
          </TableHead>
          <TableHead className="w-24">
            <BodyText bold={true} size="sm" textColor="tertiary">
              Message
            </BodyText>
          </TableHead>
          <TableHead>
            <span />
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody columnCount={6} isLoading={isLoading} isError={isError}>
        {messages?.map((message) => (
          <MessageRow
            key={message.patient.id}
            message={message}
            archived={archived}
          />
        ))}

        {!messages?.length && (
          <TableRow>
            <TableCell colSpan={7} className="text-center h-96">
              <BodyText bold={true} size="sm">
                No Messages
              </BodyText>
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};
